import { render, staticRenderFns } from "./followInfo.vue?vue&type=template&id=3db04d40&scoped=true&"
import script from "./followInfo.vue?vue&type=script&lang=js&"
export * from "./followInfo.vue?vue&type=script&lang=js&"
import style0 from "./followInfo.vue?vue&type=style&index=0&id=3db04d40&prod&scoped=true&lang=css&"
import style1 from "./followInfo.vue?vue&type=style&index=1&id=3db04d40&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db04d40",
  null
  
)

export default component.exports